import { connect } from "react-redux";

import ConfigParam from "../Components/Converters/ConfigParam";
import { setConfigParam, removeConfigParam, setConfigConverter } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converterconfig: state.converterconfig,
    locale: state.locale,
  };
};

const mapDispatchToProps = {
  setConfigParam,
  removeConfigParam,
  setConfigConverter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigParam);
